// Ejemplos con instrumentos.
import { part, wires, UNO } from './helpers.js';

export const EXAMPLES = [
  {
    id: 'analizador',
    category: 'Instrumentos',
    name: 'Analizador lógico: PWM y tone()',
    description: 'Mira con el analizador las señales de analogWrite (490 Hz y 980 Hz), tone() y un pin que cambia por software.',
    project: {
      name: 'Analizador lógico',
      files: {
        'sketch.ino': `// Señales para ver en la pestaña «Analizador» del panel inferior.
// CH0: PWM al 25 % (pin 9, 490 Hz)   CH1: PWM al 75 % (pin 6, 980 Hz)
// CH2: tone(8, 1000)                CH3: pin 13 cambiando en el loop

void setup() {
  pinMode(9, OUTPUT);
  pinMode(6, OUTPUT);
  pinMode(13, OUTPUT);
  analogWrite(9, 64);
  analogWrite(6, 192);
  tone(8, 1000);
}

void loop() {
  digitalWrite(13, HIGH);
  delayMicroseconds(300);
  digitalWrite(13, LOW);
  delayMicroseconds(700);
}
`,
      },
      parts: [UNO, part('la1', 'logic-analyzer', {}, { x: 4, z: -78, rot: 0 })],
      wires: wires([
        ['la1:CH0', 'uno:9', 'green'],
        ['la1:CH1', 'uno:6', 'blue'],
        ['la1:CH2', 'uno:8', 'yellow'],
        ['la1:CH3', 'uno:13', 'orange'],
        ['la1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
];
